import { render } from "./BottomBar.vue?vue&type=template&id=d5d32bb6&scoped=true"
import script from "./BottomBar.vue?vue&type=script&lang=js"
export * from "./BottomBar.vue?vue&type=script&lang=js"

import "./BottomBar.vue?vue&type=style&index=0&id=d5d32bb6&scoped=true&lang=css"
import "./BottomBar.vue?vue&type=style&index=1&id=d5d32bb6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5d32bb6"]])

export default __exports__